// Iconos SVG inline (sin librerias). Estilo heroicons-outline, 20px,
// stroke=currentColor para heredar el color del contenedor.

import iconoAppUrl from "../img/icono-pedipan.jpeg";

/** Logo de la app (el mismo que queda en la pantalla de inicio del telefono). */
export const logoApp = (clase = "h-7 w-7"): string =>
  `<img src="${iconoAppUrl}" alt="" class="${clase} shrink-0 rounded-lg" />`;

const svg = (d: string, extra = ""): string =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="h-5 w-5 ${extra}">${d}</svg>`;

export const iconoLapiz = svg(
  `<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>`,
);
export const iconoMas = svg(`<path d="M12 5v14M5 12h14"/>`);
export const iconoTacho = svg(
  `<path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6"/><path d="M10 11v6M14 11v6"/>`,
);
export const iconoImpresora = svg(
  `<path d="M6 9V3h12v6M6 18H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2"/><path d="M6 14h12v7H6z"/>`,
);
export const iconoBuscar = svg(`<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>`);
export const iconoChevron = svg(`<path d="m6 9 6 6 6-6"/>`, "transition-transform");
export const iconoRevertir = svg(`<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>`);
export const iconoPan = svg(
  `<path d="M4 11a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8H8a4 4 0 0 1-4-4Z"/><path d="M8 7v8M12 7v8M16 7v8"/>`,
);
export const iconoMenu = svg(`<path d="M4 6h16M4 12h16M4 18h16"/>`);
export const iconoAyuda = svg(
  `<circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.8 2.1c-.8.5-1.3 1-1.3 1.9"/><circle cx="12" cy="16.8" r=".5"/>`,
);
export const iconoCerrar = svg(`<path d="M6 6l12 12M18 6L6 18"/>`);
export const iconoFlechaDer = svg(`<path d="m9 6 6 6-6 6"/>`);
/** Grupos de produccion: varias piezas que confluyen en un total. */
export const iconoGrupos = svg(
  `<rect x="3" y="4" width="6" height="5" rx="1"/><rect x="3" y="13" width="6" height="5" rx="1"/><path d="M9 6.5h4a2 2 0 0 1 2 2v4.5a2 2 0 0 0 2 2h2"/><path d="M9 15.5h4"/>`,
);

// Icono por ruta del nav (para el menu movil).
const RUTA_ICONO: Record<string, string> = {
  "#/pedido": `<path d="M6 3h12v18l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5L4 21V3h2Z"/><path d="M9 8h6M9 12h6"/>`,
  "#/produccion": `<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M6.5 6.5h.01"/>`,
  "#/cuentas": `<rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9v6M18 9v6"/>`,
  "#/listas": `<path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>`,
  "#/clientes": `<circle cx="9" cy="8" r="3"/><path d="M4 20a5 5 0 0 1 10 0"/><path d="M17 6a3 3 0 0 1 0 6"/><path d="M15.5 20a5 5 0 0 1 5-5"/>`,
  "#/productos": `<path d="M21 8l-9-5-9 5 9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>`,
  "#/categorias": `<path d="M20.5 11.5 12 3H4v8l8.5 8.5a2 2 0 0 0 2.83 0l5.17-5.17a2 2 0 0 0 0-2.83Z"/><circle cx="7.5" cy="7.5" r="1.2"/>`,
  "#/pedidos": `<path d="M8 4h9a2 2 0 0 1 2 2v14l-3-2-3 2-3-2-3 2V6a2 2 0 0 1 2-2Z"/><path d="M9 9h7M9 13h7"/>`,
  "#/subas": `<path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/>`,
  "#/informes": `<path d="M3 3v18h18"/><rect x="7" y="12" width="3" height="6"/><rect x="12" y="8" width="3" height="10"/><rect x="17" y="5" width="3" height="13"/>`,
  "#/empresas": `<path d="M3 21h18"/><path d="M5 21V5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v16"/><path d="M14 9h4a1 1 0 0 1 1 1v11"/><path d="M8 7h3M8 11h3M8 15h3"/>`,
  "#/usuarios": `<circle cx="9" cy="8" r="3"/><path d="M4 20a5 5 0 0 1 10 0"/><path d="M17 6a3 3 0 0 1 0 6"/><path d="M15.5 20a5 5 0 0 1 5-5"/>`,
  "#/auditoria": `<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/>`,
};
export function iconoRuta(hash: string): string {
  return svg(RUTA_ICONO[hash] ?? `<circle cx="12" cy="12" r="8"/>`);
}

// Icono por area/categoria de produccion (fallback: pan generico).
const PORNOMBRE: Record<string, string> = {
  Bizcochos: `<path d="M12 3c3 2 4 5 4 8a4 4 0 0 1-8 0c0-3 1-6 4-8Z"/>`,
  Confiteria: `<path d="M4 20h16M6 20v-4a6 6 0 0 1 12 0v4"/><path d="M12 6V3"/>`,
  Galleta: `<circle cx="12" cy="12" r="8"/><circle cx="9" cy="10" r="1"/><circle cx="14" cy="9" r="1"/><circle cx="13" cy="14" r="1"/>`,
  Medialunas: `<path d="M16 4a8 8 0 1 0 4 12A6 6 0 0 1 16 4Z"/>`,
  Sandwicheria: `<path d="M3 8h18l-2 3H5Z"/><path d="M5 11h14v2H5z"/><path d="M4 15h16l-2 3H6Z"/>`,
  Roscas: `<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>`,
  Rotiseria: `<path d="M12 3v3M8 6h8M6 9h12l-1 9a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2Z"/>`,
};

export function iconoCategoria(nombre: string): string {
  const d = PORNOMBRE[nombre] ?? `<path d="M4 11a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8H8a4 4 0 0 1-4-4Z"/>`;
  return svg(d);
}
